import React, { useState, useEffect, useMemo} from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { 
  Calculator, 
  GraduationCap, // Para gestión académica
  ClipboardList, // Para un listado o historial
  CalendarDays, 
  CreditCard, 
  BookOpen,
  MenuIcon,
  X,
  LogOut,
} from 'lucide-react';
import { useAuth } from '../../metodos/AuthContext'; // Ajusta esta ruta según tu estructura
import logo from '../../assets/logo.png'; // Asegúrate de que la ruta sea correcta
import { useUsers } from '../../metodos/userContext';
import CompletarPerfilNuevoTutor from './Usuario/CompletarPerfil'; // Asegúrate de crear este componente
import PermisoInsuficiente from '../Logins/noPermisos'; // Asegúrate de crear este componente
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import CuentaInactiva from '../Logins/CuentaInactiva';
import DashboardLayout from '../DashboardLayout';

// Definimos las rutas de nuestra aplicación con iconos más relevantes
const routes = [
  { name: "Cotizar", icon: <Calculator size={20} />, path: "/dashboard" },
  { name: "Tesis Manager", icon: <GraduationCap size={20} />, path: "/tesis_manager", permission: '4. Realizacion de clases virtuales' },
  { name: "Mis Cotizaciones", icon: <ClipboardList size={20} />, path: "/historial_solicitudes" },
  { name: "Calendario", icon: <CalendarDays size={20} />, path: "/calendario" },
  { name: "Pagos", icon: <CreditCard size={20} />, path: "/pagos" },
  { name: "Recursos", icon: <BookOpen size={20} />, path: "/recursos" },
];


// Componente principal que integra todo
const HomeScreenTutor = () => {
  
  const { usuario ,loadingUsuario, errorUsuario} = useUsers();
  const navigate = useNavigate();
  const location = useLocation();

  //filtrado de rutas
  const filteredRoutes = useMemo(() => {
    console.log("🚀 Inicia el cálculo de rutas filtradas por Tipo de Servicio...");

    // 1. Verifica si 'usuario.tiposServicios' es un array válido.
    if (!usuario || !Array.isArray(usuario.tipoServicios)) {
      console.warn("⚠️ 'usuario.tiposServicios' no es un array o no existe. Solo se mostrarán rutas públicas.");
      // Devuelve solo las rutas que no requieren un servicio/permiso.
      return routes.filter(route => !route.permission);
    }

    // 2. Muestra los servicios que maneja el usuario.
    const userServices = usuario.tipoServicios;
    console.log("✅ Servicios que maneja el usuario:", userServices);

    const finalRoutes = routes.map(route => {
      console.log(`\nProcessing route: ${route.name}`);

      // 3. Filtra los submenús (si los hubiera) basados en los servicios del usuario.
      const visibleSubmenus = route.submenu?.filter(subItem => {
          const requiredService = subItem.permission;
          // La condición es que no requiera servicio, o que el usuario lo tenga.
          const hasService = userServices.includes(requiredService);
          
          console.log(
            `-- Submenu: '${subItem.name}' | Servicio requerido: '${requiredService}' | ¿Lo tiene?: ${hasService}`
          );
          
          return !requiredService || hasService;
        }) || [];

      console.log(`-> Submenús visibles para '${route.name}':`, visibleSubmenus.map(s => s.name));

      // 4. Determina si la ruta principal es visible.
      const mainRequiredService = route.permission;
      // La condición es la misma: no requiere servicio, o el usuario lo tiene.
      const hasMainService = !mainRequiredService || userServices.includes(mainRequiredService);

      console.log(`-> Ruta principal '${route.name}' | Servicio requerido: '${mainRequiredService}' | ¿Lo tiene?: ${hasMainService}`);
      
      const hasVisibleSubmenus = visibleSubmenus.length > 0;
      const isVisible = hasMainService || hasVisibleSubmenus;

      console.log(`-> ¿Se mostrará '${route.name}'?`, isVisible ? "Sí" : "No");
      
      // 5. Devuelve la ruta si cumple las condiciones.
      if (isVisible) {
        return { ...route, submenu: visibleSubmenus };
      }
      
      return null;
    }).filter(Boolean); // Filtra los nulos que no cumplieron las condiciones.

    // 6. Muestra el resultado final.
    console.log("\n✅✅✅ Rutas finales filtradas:", finalRoutes.map(r => r.name));
    
    return finalRoutes;

  }, [usuario.tiposServicios]); // La dependencia ahora es la lista de servicios.

  //verificar que solo pueden entrar tutores
  if(usuario.rol !="TUTOR"){
    return <PermisoInsuficiente />;
  }

  //verificar si tutor no esta expulsado
  if(usuario.expulsado){
    return <PermisoInsuficiente />;
  }

  //verificar que tutor no este sancionada , proximamente ...
  if(!usuario.activo){
    return <CuentaInactiva />;
  }

  //pasar
  return (
    <DashboardLayout 
      routes={filteredRoutes} // Pasamos las rutas ya filtradas
      user={usuario}          // Pasamos el usuario para el Topbar
      appTitle="Portal Tutor"
      customLogo={logo}
    />
  );

};

export default HomeScreenTutor;